import { useQuery } from '@tanstack/react-query'
import { fetchFunctionalChecklistById } from '../services/fuctional_checklist';

const GetFunctionalChecklistById = (checklistId) => {
 const functionalChecklist = useQuery({
    queryKey:['functional_score_by_entry', checklistId],
    queryFn: () => fetchFunctionalChecklistById(checklistId),
    enabled: !!checklistId,
 })
 return functionalChecklist;
}

export default GetFunctionalChecklistById